import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type PartnerService from 'tio-employee/services/partner';
import type Store from '@ember-data/store';

export default class AuthenticatedLpnShowRoute extends Route {
  @service declare store: Store;
  @service declare router: RouterService;
  @service declare partner: PartnerService;

  beforeModel() {
    // This route is no longer in use, redirect to index
    this.router.transitionTo('authenticated.lpn.index');
  }
}
